module.exports = __webpack_public_path__ + "img/liucheng1.0b484d12.jpg";